import { NextPage } from 'next';
import Head from 'next/head';
import styled, { ThemeProvider } from 'styled-components';
import HeroSection from '../components/BrandSitesV2/About/HeroSection';
import HistorySection from '../components/BrandSitesV2/About/HistorySection';
import StatisticSection from '../components/BrandSitesV2/About/StatisticSection';
import TeamSection from '../components/BrandSitesV2/About/TeamSection';
import Footer from '../components/BrandSitesV2/common/Footer';
import { BrandSitesV2GlobalStyle, BrandSitesV2Theme } from '../components/BrandSitesV2/common/GlobalStyle';
import Header from '../components/BrandSitesV2/common/Header';
import StorySection from '../components/BrandSitesV2/About/StorySection';
import RelationSection2 from '../components/BrandSitesV2/About/RelationSection2';
import StickyAppDownloadButton from '../components/BrandSitesV2/common/StickyAppDownloadButton';
import { GoogleAnalyticsBrandsiteScript } from '../components/GoogleAnanlytics';

const About: NextPage = () => {
  return (
    <>
      <Head>
        <title>청연이야기</title>
        <meta property="og:title" content="청연이야기" />
        <meta name="description" content="일상에 도움이 필요한 순간, 청연" />
        <meta property="og:description" content="일상에 도움이 필요한 순간, 청연" />
        <meta
          name="keywords"
          content="청연,청소연구소,집청소,가사도우미,사무실 청소,이사청소,입주청소,에어컨청소,청연케어"
        />
        <meta
          name="og:keywords"
          content="청연,청소연구소,집청소,가사도우미,사무실 청소,이사청소,입주청소,에어컨청소,청연케어"
        />
        <meta property="og:url" content="https://www.cleaninglab.co.kr/about" />
        <link rel="canonical" href="https://www.cleaninglab.co.kr/about" />
        <meta property="og:image" content="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/thumb.png" />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="360" />
        <meta property="og:image:type" content="image/png" />
        <GoogleAnalyticsBrandsiteScript />
      </Head>
      <BrandSitesV2GlobalStyle />
      <ThemeProvider theme={BrandSitesV2Theme}>
        <Header textColor="#ffffff" />
        <Main>
          <HeroSection />
          <RelationSection2 />
          <StickyContainer>
            <StatisticSection />
            <HistorySection />
            <TeamSection />
            <StorySection />
            <StickyAppDownloadButton />
          </StickyContainer>
        </Main>
        <Footer />
      </ThemeProvider>
    </>
  );
};

export default About;

const Main = styled.main``;

const StickyContainer = styled.div``;
